import { removeFieldValidation } from './utils';

const cityValidation = (field) => {
    const fieldValue = field?.value?.toString() || '';
    if (/^\d+$/.test(fieldValue)) {
        return {
            validatedField: {
                id: field.id,
                isValid: false,
                errorMap: {
                    errorKey: 'city-validation-error',
                },
            },
            isFieldValid: false,
        };
    }
    return removeFieldValidation(field);
};

export default cityValidation;
